import { Component, OnInit, Input, Output, EventEmitter, HostBinding } from '@angular/core';
import { MStepper } from '@argalis-apps/angular-global';
import { MResa } from '@argalis-apps/models';
import { CartConfigService } from '../../services/cart-config/cart-config.service';
import { AuthService } from '../../../auth/services/auth/auth.service';

@Component({
  selector: 'ags-participant',
  templateUrl: './nombre-participant.component.html',
  styleUrls: ['./nombre-participant.component.scss']
})
export class NombreParticipantComponent implements OnInit, MStepper.IStepComponent {
  @HostBinding('class') themeFlag: string;
  @Input() public step: MStepper.IStep;
  @Output() public backStep = new EventEmitter<any>();
  @Output() public validation = new EventEmitter<any>();
  public currentResa: MResa.CResa;
  public numberOfparticipant: number[] = [];
  public checkNumebr = false;

  constructor(private authService: AuthService, private cartConfigService: CartConfigService) {}

  ngOnInit() {
    this.themeFlag = `${this.themeFlag || ''} ${this.cartConfigService.themingClassName}`;
    this.currentResa = this.step.dataInput;
    for (let i = 1; i <= this.currentResa.selected_session.places; i++) {
      this.numberOfparticipant.push(i);
    }
  }
  clientTypeChange(select_number) {
    if (select_number > 0) {
      this.checkNumebr = true;
      this.currentResa.nb_places_reserve = select_number;
    }
  }
  public goToNextStep() {
    this.validation.emit(true);
  }
}
